<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Jaringan",

  metaInfo: { title: "Jaringan" },

  extends: View,

  mixins: [
    LoadSections([
      // 'hero-alt',
      "network",
      "info"
    ])
  ],

  props: {
    id: {
      type: String,
      default: "network"
    }
  }
};
</script>
